import { render, staticRenderFns } from "./ModelVersionInfo.vue?vue&type=template&id=ef507644&scoped=true"
import script from "./ModelVersionInfo.vue?vue&type=script&lang=js"
export * from "./ModelVersionInfo.vue?vue&type=script&lang=js"
import style0 from "./ModelVersionInfo.vue?vue&type=style&index=0&id=ef507644&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef507644",
  null
  
)

export default component.exports